import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetfixedcostspage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetFixedCostsPage } = await import(
        /* webpackChunkName: "Login" */ '../../../components/pages/private/BudgetFixedCostsPage'
      )
      return {
        default: BudgetFixedCostsPage,
      }
    })}
    exact
    key={paths.fixedCostsImport}
    path={paths.fixedCostsImport}
  />,
]
